import { useState, useEffect, useCallback } from 'react';

export const useTimeRemaining = (initialRemainingSeconds) => {
    const [remainingSeconds, setRemainingSeconds] = useState(initialRemainingSeconds);
    const [timeDisplay, setTimeDisplay] = useState({ hours: '00', minutes: '00', seconds: '00' });
    const [isExpired, setIsExpired] = useState(false);

    const calculateTimeDisplay = useCallback((seconds) => {
        if (!seconds || seconds <= 0) {
            return { hours: '00', minutes: '00', seconds: '00' };
        }

        const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
        const minutes = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
        const secs = Math.floor(seconds % 60).toString().padStart(2, '0');

        return { hours, minutes, seconds: secs };
    }, []);

    useEffect(() => {
        setRemainingSeconds(initialRemainingSeconds);
    }, [initialRemainingSeconds]);

    useEffect(() => {
        if (!remainingSeconds) return;

        setTimeDisplay(calculateTimeDisplay(remainingSeconds));

        const interval = setInterval(() => {
            setRemainingSeconds(prev => {
                const newValue = prev - 1;
                if (newValue <= 0) {
                    clearInterval(interval);
                    setIsExpired(true);
                    return 0;
                }
                return newValue;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [remainingSeconds, calculateTimeDisplay]);

    useEffect(() => {
        setTimeDisplay(calculateTimeDisplay(remainingSeconds));
    }, [remainingSeconds, calculateTimeDisplay]);

    return { ...timeDisplay, isExpired };
}; 